import type { MemberLevel } from '@keetcheck/shared';
import { theme } from '../theme.js';

export const LEVELS: MemberLevel[] = ['probationary', 'supervised', 'level_1', 'level_2'];

export const LEVEL_LABEL: Record<MemberLevel, string> = {
  probationary: 'Probationary',
  supervised:   'Supervised',
  level_1:      'Level 1',
  level_2:      'Level 2',
};

/** Days of warning before a qualification expires. */
export const EXPIRY_WARNING_DAYS = 30;

export type ExpiryState = 'none' | 'ok' | 'soon' | 'expired';

/** expiresAt is 'YYYY-MM-DD'; a qualification is valid through that day. */
export function expiryState(expiresAt: string | null | undefined, today = new Date()): ExpiryState {
  if (!expiresAt) return 'none';
  const end = new Date(`${expiresAt}T23:59:59`);
  const days = (end.getTime() - today.getTime()) / 86_400_000;
  if (days < 0) return 'expired';
  if (days <= EXPIRY_WARNING_DAYS) return 'soon';
  return 'ok';
}

export function expiryColors(state: ExpiryState) {
  if (state === 'expired') return theme.status.danger;
  if (state === 'soon') return theme.status.warn;
  return theme.status.muted;
}

export function formatDate(ymd: string): string {
  return new Date(`${ymd}T00:00:00`).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}
